import React from "react";
import { useDispatch } from "react-redux";
import { Row } from "components/Layout/Grid";
import StatusCircle from "components/StatusCircle";
import Text from "components/Text";
import { EnumToArray } from "utils/enumArray/enumHelpers";
import { Button } from "components/Button";
import AddEditEmployee from "components/EmployeeManagerSlider";
import editIcon from 'img/edit-icon-table.svg';

import { IUser, UserProfileTypes, UserRoleTypes } from "models/User";
import { IBusinessUnits } from "models/BusinessUnits";
import { NoFilter } from "pages/Quotes/components/MapProductTable/MapProductRow/styles";

export function modelEmployeeManager(user: IUser, statusInput: string | undefined, getUsers: any) {

  const dispatch = useDispatch();

  const model = [
    {
      label: 'Status',
      key: 'enabled',
      size: 80,
      maxSize: 80,
      Component: (data: IUser) => (
        <Row className="justify-center w-100">
          <StatusCircle value={data?.enabled || false} pending={data?.pending ?? false} />
        </Row>
      ),
    },
    { label: 'Nome', key: 'fullName', size: 180, maxSize: 180 },
    {
      label: 'Usuário de Rede',
      key: 'username',
      size: 200,
      maxSize: 200,
      noFilter: true
    },
    { label: 'Email', key: 'email', size: 200, maxSize: 200, noFilter: true },
    {
      label: 'Nível de acesso',
      key: 'acessLevel',
      size: 120,
      maxSize: 120,
      noFilter: true,
      Component: (data: IUser) => (
        <Text className="color-blue-gray" size={12} showTip>
          {data.roles ? UserRoleTypes?.[data.roles[0]] : '-'}
        </Text>
      ),
    },
    {
      label: 'Perfil',
      key: 'profileType',
      size: 120,
      noFilter: true,
      Component: (data: any) => (
        <Text className="color-blue-gray" size={12} showTip>
          {data.profileType
            ? data.profileType
              .map(
                (profile: UserProfileTypes) =>
                  EnumToArray(UserProfileTypes).find(
                    (item) => item.key === profile
                  )?.value ?? ''
              )
              .join(',')
            : '-'}
        </Text>
      ),
    },
    {
      label: 'BU',
      key: 'businessUnits',
      size: 120,
      noFilter: true,
      Component: (data: IUser) => (
        <div className="overflow-x-hidden">
          {' '}
          <Text className="color-blue-gray" size={12} showTip>
            {data.businessUnits
              ? data.businessUnits
                .map((bu: IBusinessUnits) => bu.name)
                .join(',')
              : '-'}
          </Text>
        </div>
      ),
    },
    {
      label: 'Adicionado por',
      key: 'userWhoInvited.fullName',
      size: 110,
      maxSize: 110,
      noFilter: true,
      Component: (data: IUser) => (
        <Text className="color-blue-gray" size={12} showTip>
          {data.userWhoInvited?.fullName === user.fullName
            ? 'Você'
            : data.userWhoInvited?.fullName || '-'}
        </Text>
      ),
    },
    {
      label: 'Último acesso',
      key: 'lastAccess',
      type: 'date',
      size: 100,
      maxSize: 100,
      noFilter: true,
    },
    {
      label: '',
      size: 40,
      maxSize: 40,
      isButton: true,
      Component: (userProp: IUser) => (
        <Button
          tooltip="Editar funcionário"
          toolTipPlace="left"
          onClick={() =>
            dispatch({
              type: 'OPEN_SLIDER',
              data: {
                title: 'Editar funcionário',
                subtitle:
                  'Utilize os campos abaixo para alterar informações do funcionário.',
                content: AddEditEmployee,
                state: { userProp, getUsers },
              },
            })
          }
        >
          <img src={editIcon} alt="" />
        </Button>
      ),
    }
  ];

  if (statusInput !== '0' && statusInput !== 'active') {
    // remove o ultimo item do array que é o botão de editar
    // quando for usuarios inativos ele não permite editar
    model.splice(model.length - 1, 1);
  }

  return model;
}
